function setProviderReducer(currentState = "", action) {
  switch (action.type) {
    case "SET_PROVIDER":
      return action.payload;
    default:
      break;
  }
  return currentState;
}

export default setProviderReducer;
